const externalLoginStyles = {
    login_page: {
        maxWidth: '900px',
        margin: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    login_area: {
        maxWidth: '528px',
        background: '#fff',
        borderRadius: '5px',
        padding: '34px',
        boxShadow: '0px 2px 18px 2px rgba(6, 47, 98, 0.14)',
        margin: '0  auto'
    },
    login_title: {
        fontWeight: '600',
        fontSize: '32px',
        textAlign: 'center',
        color: '#1B2354',
        margin: '150px 0 24px 0',
        fontFamily: '"Open Sans", sans- serif'
    },
    step2_container: {
        display: "flex",
        marginBottom: "5px",
        alignItems: "center",
        justifyContent: "space-between",
    },

    login_subtitle: {
        fontWeight: '600',
        fontSize: '24px',
        textAlign: 'center',
        color: '#1B2354',
        marginBottom: '24px',
        fontFamily: '"Open Sans", sans- serif'
    },
    login_button: {
        color: '#fff',
        width: '100%',
        margin: ' 0',
        padding: '10px 1rem',
        background: '#1B2354',
        borderRadius: '5px',
        fontWeight: '600',
        fontSize: '16px',
        textDecoration: 'none',
        display: 'block',
        border: 'none'
    },
    login_button_disabled: {
        color: '#fff',
        width: '100%',
        margin: ' 0',
        padding: '10px 1rem',
        background: '#aaa',
        borderRadius: '5px',
        fontWeight: '600',
        fontSize: '16px',
        textDecoration: 'none',
        display: 'block',
        border: 'none'
    },
    goto_btn: {
        color: '#fff',
        display: 'table',
        margin: '1rem 0 0',
        padding: '14px 1rem',
        borderRadius: '5px',
        fontWeight: '600',
        fontSize: '16px',
        background: 'green',
        textDecoration: 'none',
        textAlign: 'center'
    }
}

export { externalLoginStyles }